var map = {
	"./resource_amber.png": "d499",
	"./resource_animals.png": "37b7",
	"./resource_colony.png": "810e",
	"./resource_dwarf_beer.png": "b86f",
	"./resource_dyes.png": "f58e",
	"./resource_furs.png": "fcb3",
	"./resource_gemstones.png": "701a",
	"./resource_gold.png": "f0b9",
	"./resource_gold_idols.png": "1d4a",
	"./resource_grain.png": "3699",
	"./resource_iron.png": "fff6",
	"./resource_marble.png": "8542",
	"./resource_medicine.png": "246b",
	"./resource_obsidian.png": "5908",
	"./resource_pottery.png": "09cb",
	"./resource_salt.png": "4280",
	"./resource_savage_orcs.png": "97a5",
	"./resource_spices.png": "843d",
	"./resource_timber.png": "df0e",
	"./resource_trinkets.png": "f375",
	"./resource_vortex_site.png": "0efc",
	"./resource_wine.png": "924b",
	"./siege_defence.png": "f290",
	"./strategic_location.png": "00fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2229";